import { apiService } from './api';

export const contactService = {
  getAll: async () => {
    try {
      const response = await apiService.get('/Contact/all');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch Contacts');
    }
  },

 getPaginatedContacts: async (page = 1, pageSize = 10, search = '') => {
    try {
      let url = `/Contact/paginated?page=${page}&pageSize=${pageSize}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      
      const response = await apiService.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch contacts');
    }
  },

  getById: async (id) => {
    try {
      const response = await apiService.get(`/Contact/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch Contact');
    }
  },

  create: async (contactData) => {
    try {
      const response = await apiService.post('/Contact/create', contactData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create Contact');
    }
  },

  update: async (id, contactData) => {
    try {
      const response = await apiService.put(`/Contact/${id}`, contactData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update Contact');
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(`/Contact/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete Contact');
    }
  },

};

export default contactService;
